import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isDisabled: boolean
}

export const Item = styled.div<Props>`
	padding: 2px 6px;
	cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
	color: ${({ theme }) => theme.color.input.menuOption};
	font-size: ${helpers.font.size.base};
	text-align: left;

	&:hover > div {
		background-color: ${({ theme, isDisabled }) => (isDisabled ? theme.color.input.menuOptionBackgroundHoverDisabled : theme.color.input.menuOptionBackgroundHover)};
	}
`
